"use client";

import { c as _c } from "react/compiler-runtime";
import { motion } from "framer-motion";
import { HOME, mediaPath } from "@/lib/media";
import Link from "next/link";
import { MoveRight } from "lucide-react";
const MISSION_STYLE = `
    .mission-grain::after {
        content: '';
        position: absolute;
        inset: 0;
        background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)' opacity='0.04'/%3E%3C/svg%3E");
        pointer-events: none;
        z-index: 0;
    }
`;
const Mission = () => {
  const $ = _c(18);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <style>{MISSION_STYLE}</style>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="absolute inset-0 pointer-events-none"><div className="absolute left-[50%] top-0 bottom-0 w-px bg-[#0F1C2E]/[0.03]" /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      opacity: 0,
      x: -40
    };
    t3 = {
      opacity: 1,
      x: 0
    };
    t4 = {
      once: true
    };
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      duration: 1,
      ease: [0.16, 1, 0.3, 1]
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="absolute inset-3 sm:inset-4 md:inset-6 border border-white/20 z-10 pointer-events-none mix-blend-overlay transition-all duration-700 group-hover:inset-2 sm:group-hover:inset-3" />;
    t7 = <img src={mediaPath(HOME.missionNeoBihar)} alt={HOME.missionNeoBiharAlt} className="w-full h-full object-cover scale-105 group-hover:scale-110 transition-transform duration-[1.5s] ease-out grayscale-[20%] sepia-[10%] contrast-[1.1]" />;
    $[6] = t6;
    $[7] = t7;
  } else {
    t6 = $[6];
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <motion.div initial={t2} whileInView={t3} viewport={t4} transition={t5} className="w-full lg:w-[65%] lg:pr-12 relative z-0"><div className="relative aspect-[3/2] sm:aspect-[4/3] lg:aspect-[16/11] overflow-hidden rounded-sm group shadow-[0_8px_30px_rgba(26,20,16,0.06)]">{t6}{t7}<div className="absolute top-4 sm:top-8 md:top-12 left-4 sm:left-8 md:left-12 bg-[#0F1C2E]/85 backdrop-blur-md border border-white/10 p-3 sm:p-5 shadow-2xl z-10"><p className="font-display text-[24px] sm:text-[32px] md:text-[40px] leading-none text-[#C9A84C] italic mb-1">1838</p><div className="w-4 sm:w-6 h-px bg-white/30 mb-1.5 sm:mb-2.5" /><p className="font-body text-[7px] sm:text-[8.5px] tracking-[0.2em] sm:tracking-[0.25em] uppercase text-white/80">The Journey Begins</p></div><div className="absolute inset-0 bg-gradient-to-r from-transparent to-[#0F1C2E]/20 z-0" /></div><div className="hidden lg:block absolute -bottom-6 right-0 w-3/4 h-px bg-[#0F1C2E]/10" /><div className="hidden lg:block absolute bottom-0 -right-6 w-px h-3/4 bg-[#0F1C2E]/10" /></motion.div>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t10;
  let t11;
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      opacity: 0,
      y: 40
    };
    t10 = {
      opacity: 1,
      y: 0
    };
    t11 = {
      once: true
    };
    $[9] = t10;
    $[10] = t11;
    $[11] = t9;
  } else {
    t10 = $[9];
    t11 = $[10];
    t9 = $[11];
  }
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      duration: 1,
      ease: [0.16, 1, 0.3, 1],
      delay: 0.2
    };
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="flex items-center gap-2 sm:gap-3 mb-5 sm:mb-8"><div className="w-8 h-px bg-[#C9A84C]" /><span className="font-body text-[10px] md:text-[11px] tracking-[0.25em] uppercase text-[#C9A84C] font-light">Our Mission</span></div>;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <h2 className="font-display text-[30px] sm:text-[38px] md:text-[40px] lg:text-[46px] font-light leading-[1.05] tracking-[-0.01em] text-[#F4EFE6] mb-5 sm:mb-8">Preserving the Voices of <br className="hidden sm:block" /><em className="text-[#C9A84C] italic">Forgotten Journeys</em></h2>;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  let t15;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <div className="font-body text-[13.5px] sm:text-[14.5px] md:text-[15.5px] font-light leading-[1.7] sm:leading-[1.8] text-white/70 flex flex-col gap-4 sm:gap-5 mb-7 sm:mb-10"><p>The Girmitiya Council is building a global digital archive dedicated to preserving the stories, documents, migration records, and cultural heritage of Indian indentured labourers.</p><p>From 1834 to 1917, approximately 1.3 million Indians were transported under indenture contracts to work in British and French colonies. Their descendants form a living legacy we are committed to honouring.</p></div>;
    $[15] = t15;
  } else {
    t15 = $[15];
  }
  let t16;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <div className="flex flex-wrap gap-1.5 sm:gap-2 mb-7 sm:mb-10">{["Digital Archive", "Migration Records", "Oral Histories"].map(_temp)}</div>;
    $[16] = t16;
  } else {
    t16 = $[16];
  }
  let t17;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <>{t0}<section className="relative font-body bg-[#F4EFE6] py-16 sm:py-24 md:py-32 overflow-hidden border-t border-[#0F1C2E]/05">{t1}<div className="max-w-[1280px] mx-auto px-4 sm:px-6 md:px-8"><div className="relative flex flex-col lg:flex-row items-center gap-8 sm:gap-12 lg:gap-0">{t8}<motion.div initial={t9} whileInView={t10} viewport={t11} transition={t12} className="w-full lg:w-[45%] lg:-ml-[10%] relative z-10"><div className="relative mission-grain bg-[#0F1C2E] p-6 sm:p-10 md:p-14 lg:p-16 shadow-[0_30px_80px_rgba(26,20,16,0.25)] border border-white/5"><div className="relative z-10">{t13}{t14}{t15}{t16}<Link href="/about" className="font-body inline-flex items-center gap-2.5 px-6 sm:px-8 py-3.5 sm:py-4 bg-[#C9A84C] text-[#0F1C2E] text-[11px] sm:text-[12px] font-medium tracking-[0.08em] uppercase hover:bg-[#F4EFE6] transition-colors duration-300 group w-full justify-center sm:w-auto sm:justify-start">Discover Our Story<MoveRight size={14} strokeWidth={1.5} className="transition-transform duration-300 group-hover:translate-x-1" /></Link></div></div></motion.div></div></div></section></>;
    $[17] = t17;
  } else {
    t17 = $[17];
  }
  return t17;
};
export default Mission;
function _temp(tag) {
  return <span key={tag} className="font-body text-[8.5px] sm:text-[9.5px] tracking-[0.1em] px-2.5 sm:px-3 py-1 sm:py-1.5 border border-white/15 text-white/50 uppercase bg-white/5">{tag}</span>;
}